__turbopack_context__.v({
  "list": "header-nav-module__FbEcPq__list",
  "nav": "header-nav-module__FbEcPq__nav",
});
